// extracted by mini-css-extract-plugin
module.exports = {"w17zbdjf":"w17zbdjf"};